module.exports = __webpack_public_path__ + "img/loading.e4b6323.gif";